import React from 'react';

import {DocumentList} from 'components/documents';
import config from 'config';

export const showRating = (rating) => {
  switch(rating) {
    case 1:
      return "Дуже погано (1)";
    case 2:
      return "Погано (2)";
    case 3:
      return "Нормально (3)";
    case 4:
      return "Добре (4)";
    case 5:
      return "Дуже добре (5)";
    default:
  }
}


export const RatingDetailList = ({ rating }) => (
  <DocumentList>
    <li>Реєстраційний номер: <strong>{rating.get('id')}</strong></li>
    <li>Оцінка (від 1 до 5): <strong>{showRating(rating.get('rating'))}</strong></li>
    <li>Лікар: <strong>{rating.get('staff_data').get('user_data').get('last_name')} {rating.get('staff_data').get('user_data').get('first_name')} {rating.get('staff_data').get('user_data').get('middle_name')}</strong></li>
    <li>Лікарня: <strong>{rating.get('staff_data').get('institution_data').get('full_title')}</strong></li>
    <li>Дата створення: <strong>{new Date(rating.get('date_created')).toLocaleString('uk-UA', config.options)}</strong></li>
    <li>Коментар: <strong>{rating.get('comment')? rating.get('comment') : "Відсутній"}</strong></li>
  </DocumentList>
);



// WEBPACK FOOTER //
// ./src/administration/rating/rating-detail-list.js